import React, { useContext } from 'react';

import { DataContext2 } from '../contexts/DataContext2';
import CountryPage from './RegistrationSteps.js/CountryPage';
import PhoneNumberPage from './RegistrationSteps.js/PhoneNumberPage';
import SmsConfirmationPage from './RegistrationSteps.js/SmsConfirmationPage';
import FirstNamePage from './RegistrationSteps.js/FirstNamePage';
import LastNamePage from './RegistrationSteps.js/LastNamePage';
import DobPage from './RegistrationSteps.js/DobPage';
import ZipPage from './RegistrationSteps.js/ZipPage';
import EmailPage from './RegistrationSteps.js/EmailPage';
import SubmitPage from './RegistrationSteps.js/SubmitPage';
import DevicesPage from './RegistrationSteps.js/DevicesPage';
import FinishPage from './RegistrationSteps.js/FinishPage';

const StepsPages = [
  CountryPage,
  PhoneNumberPage,
  FirstNamePage,
  LastNamePage,
 // ZipPage,
  //DobPage,
  EmailPage,
  FinishPage,
];

function RegistrationPage2() {
  const { currentStep } = useContext(DataContext2);
  const PageComponent = StepsPages[currentStep];
  return <PageComponent />;
}

export default RegistrationPage2;
